// path: frontend/src/utils/entityState.js
/**
 * UI-хелперы состояния сущностей (архив/активность). Серверные флаги
 * isActive и archived приходят в DTO, isCascadeArchivedTask — чисто UI
 * (каскадное архивирование по проекту).
 */
export const isArchived = (entity) =>
  !!entity &&
  (entity.archived === true ||
    entity.status === "closed" ||
    entity.status === "cancelled");

export const isCascadeArchivedTask = (task) =>
  !!task && task.archivedByProject === true;
